export const getDateTimeNow = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0");
  const day = now.getDate().toString().padStart(2, "0");
  const hours = now.getHours().toString().padStart(2, "0");
  const minutes = now.getMinutes().toString().padStart(2, "0");
  const seconds = now.getSeconds().toString().padStart(2, "0");
  return `${year}-${month}-${day}_${hours}${minutes}${seconds}`;
};

export const transformDate = (dateFromApi?: Date | string) => {
  if (!dateFromApi) {
    return "";
  }
  let d = dateFromApi as Date;
  if (typeof dateFromApi === "string") {
    d = new Date(dateFromApi);
  }

  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};
